import React, { useState } from 'react';
import ContextualGreeting from './pages/ContextualGreeting';
import CTAConfiguration from './pages/CTAConfiguration';
import CTAActionLink from './pages/CTAActionLink';
import PageRuleConfiguration from './pages/PageRuleConfiguration';
import ConversionTracking from './pages/ConversionTracking';
import TeamUsers from './pages/TeamUsers';
import Integrations from './pages/Integrations';
import AllowedDomains from './pages/AllowedDomains';
import WidgetInstallationKey from './pages/WidgetInstallationKey';
import './styles.css';
import './App.css';
import './index.css';
import './theme-align.css';
import { useWorkspace } from '../integrationQA/context/WorkspaceContext';
import NotConnected from '../components/common/NotConnected';
import { USE_MOCK, isMarketingSectionConnected } from '../api/connection';

// [id, label, component, permission needed to use the tab]
const sections = [
  ['greeting','Contextual greeting',ContextualGreeting,'marketing:manage'],
  ['cta','CTA configuration',CTAConfiguration,'marketing:manage'],
  ['action','CTA action / link',CTAActionLink,'marketing:manage'],
  ['rules','Page rules',PageRuleConfiguration,'marketing:manage'],
  ['conversion','Conversion tracking',ConversionTracking,'marketing:manage'],
  ['team','Team users & roles',TeamUsers,'users:manage'],
  ['integrations','Integrations',Integrations,'marketing:manage'],
  ['domains','Allowed domains',AllowedDomains,'business:manage'],
  ['install','Widget installation key',WidgetInstallationKey,'marketing:manage'],
];
export default function MarketingTeamPage({ initialSection }) {
 const { can } = useWorkspace();
 const visible=sections.filter(x=>can(x[3]));
 // Backend mode opens on the first tab that is connected to the backend (Team users & roles).
 const firstConnected=(visible.find(x=>isMarketingSectionConnected(x[0]))||[])[0];
 const [active,setActive]=useState(initialSection || (USE_MOCK ? 'greeting' : firstConnected || 'greeting'));
 const item=visible.find(x=>x[0]===active)||visible[0]||sections[0];
 const Component=isMarketingSectionConnected(item[0]) ? item[2] : null;
 return <section className="cb-marketing-module">
  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
   <div><div className="small text-primary fw-semibold">CHATBIZZ / GROWTH</div><h1 className="h3 mb-0">Marketing &amp; Team, Integrations</h1></div>
  </div>
  <div className="d-flex flex-wrap gap-2 mb-4" role="tablist" aria-label="Marketing and team sections">
   {visible.map(([id,label])=><button key={id} type="button" role="tab" aria-selected={item[0]===id} className={`btn btn-sm ${item[0]===id?'btn-dark':'btn-outline-secondary'}`} onClick={()=>setActive(id)}>{label}</button>)}
  </div>
  {Component ? <Component/> : <NotConnected title={item[1]} compact />}
 </section>;
}
